import { call, put, takeEvery } from "redux-saga/effects";
import { GET_OURCAR } from "resources/actionTypes";
import { ourCarApi } from "services/TopSectionService";
function* fetchOurCar(action) {
  try {
    const payload = action.payload || {}
    const userOurCar = yield call(ourCarApi, payload);
    yield put({ type: GET_OURCAR.GET_OURCAR_SUCCESS, userOurCar: userOurCar });
  } catch (e) {
    yield put({ type: GET_OURCAR.GET_OURCAR_FAILED, message: e.message });
  }
}

export function* userOurCarSaga() {
  yield takeEvery(GET_OURCAR.GET_OURCAR_REQUESTED, fetchOurCar);
}